import { Component } from '@angular/core';
import { PusherService } from './core/notification/pusher.service';
import { NotificationService } from './core/notification/notification.service';
import { CallService } from './features/call/call.service';
import { Platform } from '@ionic/angular';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { GeolocationService } from './core/services/geolocation.service';
import { VivaWalletPaymentService } from './core/services/vivawalet-payment.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  constructor(
    pusherService: PusherService,
    notificationService: NotificationService,
    callService: CallService,
    platform: Platform,
    geolocationService: GeolocationService,
    paymentService: VivaWalletPaymentService
  ) {
    if (platform.is('capacitor')) {
      FirebaseCrashlytics.setEnabled({ enabled: true });
      geolocationService.initGeolocation();
      notificationService.initNotifications();
      callService.initSipCall();
      paymentService.initializeTerminal();
    }
    pusherService.initPusher();
  }
}
